import _ from 'lodash';
$( document ).ready(function() {
    if ( $('#location').length) {
        var placeSelected = false;
        var placeChanged = function(place){
            if( place ){
                var postcodeinput = document.getElementById('postcode');
                var postcodePrefixInput = document.getElementById('postcodeprefix');
                var borough = document.getElementById('borough');
                var lat = document.getElementById('lat');
                var lng = document.getElementById('lng');
                var placeName = place.name;
                lat.value=place.geometry.location.lat();
                lng.value=place.geometry.location.lng();
                postcodeinput.disabled = true;
                postcodePrefixInput.disabled = true;
                borough.disabled = true;
                lat.disabled = false;
                lng.disabled = false;
            }
        }

        var initAutocomplete = function() {
                google.maps.Circle.prototype.contains = function(latLng) {
                    return this.getBounds().contains(latLng) && google.maps.geometry.spherical.computeDistanceBetween(this.getCenter(), latLng) <= this.getRadius();
                }
                var geolocation = {
                    lat: 51.509865,
                    lng: -0.118092
                };
                var circle = new google.maps.Circle({
                    center: geolocation,
                    radius: 30000
                });
                var input = document.getElementById('location');
                var options = {
                    bounds: circle.getBounds(),
                    componentRestrictions: {
                        'country': 'uk'
                    }
                };
                var autocomplete = new google.maps.places.Autocomplete(input, options);
                var formAction = $(".search-form").attr('action');
                google.maps.event.addListener(autocomplete, 'place_changed', function() {
                    placeChanged(autocomplete.getPlace());
                    placeSelected = true;
                } );
            }();

        $(document).on('mousedown', '.development-result', function() {
            setCustomLocation($(this));
        });

        var setCustomLocation = function (obj) {
            var newObj = {};
            newObj["geometry"] = {}
            newObj["geometry"]["location"] = {}
            newObj["geometry"]["location"]["lat"] = function () { return $(obj).data("lat"); }
            newObj["geometry"]["location"]["lng"] = function () { return $(obj).data("lng"); }
            newObj["url"] = $(obj).data("url");
            window.location.replace( window.baseURL + "property/" + $(obj).data("url") );
        }
    }
});